const removeOrphans = (str) => {
    // First replace hyphens in e-mail with non-breaking hyphens
    let newStr = str.replace(/e-mail/gi, (match) => match.replace('-', '‑'));

    // Then apply existing orphans logic
    newStr = newStr.replace(/(\s)([\S])[\s]+/g, '$1$2\xa0');
    return newStr.replace(/(\s)([\S][\S])[\s]+/g, '$1$2\xa0');
};

const getTextNodes = (el) => {
    let n;
    const a = [];
    const walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);

    /* eslint-disable-next-line */
    while (n = walk.nextNode()) a.push(n);
    return a;
};

const setNodeValue = (node, value) => {
    const textNode = node;
    textNode.nodeValue = value;
};

const updateNodes = (nodes) => {
    if (nodes && nodes.length > 0) {
        Object.entries(nodes).forEach(([, textNode]) => {
            const { nodeValue } = textNode;
            if (typeof nodeValue === 'string') {
                setNodeValue(textNode, removeOrphans(textNode.nodeValue));
            }
        });
    }
};

const orphansDirective = {
    beforeMount (el) {
        const nodes = getTextNodes(el);
        updateNodes(nodes);
    },
    updated (el) {
        const nodes = getTextNodes(el);
        updateNodes(nodes);
    }
};

export default orphansDirective;
